export default "__VITE_ASSET__CDyOO_iA__"